// Indexes `array` by zero or more strings returned by `mapper` for each item
export const groupMulti = (array, mapper) => {
    const result = {};
    for (const item of array) {
        for (const key of mapper(item)) {
            result[key] = (result[key] || []).concat(item);
        }
    }
    return result;
};
//# sourceMappingURL=array.js.map